import { Toast } from 'antd-mobile';
import ywk, { utils } from '@clouderwork/ywk';
import { setOssUpload } from './oss';
import mobxState from '@src/store';

export interface IOssFile {
  id: string;
  name: string;
  url: string;
  size_str: string;
  size: number;
}

//显示选择文件的弹框，以数组形式返回选中的文件
export const uploadFile = function (
  callback: { (file: IOssFile): any },
  options?: { projectName: string; moduleName: string }
) {
  //callback在确定上传文件后触发
  // var input = '<input type="file" id="_select-file" hidden>'
  var input = document.createElement('input');
  console.log('upload start');
  input.type = 'file';
  input.id = '_select-file';
  input.style.display = 'none';
  input.multiple = false;
  // input.accept = 'audio/*, video/*, image/*';
  input.onchange = function (e: any) {
    document.getElementById('_select-file')!.remove();
    console.log('upload onchange');
    if (!e.target || !e.target.files) return;
    console.log('upload goon');
    var files = [].slice.call(e.target.files, 0);
    if (typeof callback === 'function') {
      const file: File = files[0];
      mobxState.upload.fileStatus = 'pending';
      console.log('upload oss');
      setOssUpload(file.name, file, options).then(result => {
        console.log('upload oss result', result);
        if (result && result.data && result.data.data && result.name) {
          result.data.data.name = file.name;
          mobxState.upload.fileStatus = 'done';
          callback(result.data.data as IOssFile);
        } else {
          mobxState.upload.fileStatus = 'error';
          throw new Error('Oss 文件上传后数据格式错误');
        }
      });
      // console.log(files, e);
      // setOssUpload();
      // callback(files, e)
    }
  };
  document.body.appendChild(input);
  console.log('upload input click');
  input.click();
};

export const residetUploadFile = (cb?) => {
  // 黄豆纳才上传简历方法
  const isCompany = utils.getQueryString('isCompany');
  const input = document.createElement('input');
  input.type = 'file';
  input.id = '_select-file';
  input.style.display = 'none';
  input.accept = '.pdf,.docx';
  input.multiple = false;

  input.onchange = function (e: any) {
    document.getElementById('_select-file')!.remove();
    if (!e.target || !e.target.files) return;
    var files = [].slice.call(e.target.files, 0);

    const file: File = files[0];
    if (!/\.(pdf|docx)$/.test(file.name.toLowerCase())) {
      Toast.fail('仅支持PDF,DOCX格式的文件', 2);
      return false;
    } else if (file.size / 1024 / 1024 > 8) {
      Toast.fail('文件大小不能超过8M', 2);
      return false;
    }
    mobxState.upload.fileStatus = 'pending';
    const data = new FormData();
    data.append('file', file!);
    data.append('role', isCompany ? 'company' : 'person');
    data.append('channel', 'cw');
    ywk.ajax.postFile('/resident/api/company/import/resumes', data).then(res => {
      mobxState.upload.fileStatus = 'done';
      if (+res.error_code === 0) {
        Toast.success('上传成功', 1, () => {
          cb && cb();
        });
      } else {
        mobxState.upload.fileStatus = 'error';
        Toast.fail('Oss 文件上传后数据格式错误', 1);
      }
    });
  };

  document.body.appendChild(input);
  input.click();
};
/**
 * 黄豆附件解析
 * @param successFn
 * @param failFn
 */
export const residentFileParse = (successFn?: (res: any) => void, failFn?: (msg: string) => void) => {
  mobxState.upload.parseStatus = 'pending';
  ywk.ajax.getJson('/resident/api/company/import/resumes', { role: 'company' }).then(res => {
    if (+res.error_code === 0) {
      const data = res.result;
      const { total, success, fail, details } = data;
      if (success === 1 && total === success) {
        // success = 1 解析成功
        mobxState.upload.parseStatus = 'success';
        successFn && successFn(res);
      } else if (fail === 1 && total === fail) {
        // fail = 1 解析失败
        mobxState.upload.parseStatus = 'fail';
        let msg = '';
        if (details.length && Array.isArray(details) && details[0]) {
          msg = details[0].reason;
        }
        failFn && failFn(msg);
      } else if (total > 0) {
        // 解析中
        mobxState.upload.parseStatus = 'ing';
        setTimeout(() => {
          residentFileParse(successFn, failFn);
        }, 5000);
      }
    }
  });
};
